import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { Idle, DEFAULT_INTERRUPTSOURCES, DocumentInterruptSource, StorageInterruptSource } from '@ng-idle/core';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { CustomerModel } from 'src/app/models/customer-model';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { LobbyService } from 'src/app/services/lobby/lobby.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-inactivity',
  templateUrl: './inactivity.component.html',
  styleUrls: ['./inactivity.component.scss'],
})
export class InactivityComponent implements OnInit, OnDestroy {

  public customer: CustomerModel;
  public timedOut: boolean = false;
  public idleTime: number;
  public timeOutTime: number;    
  public idleEventsTriggerList: string;
  private balanceSubscription: Subscription;

  constructor(
    private eventService: EventsService,
    private userSessionService: UserSessionService,
    private configService: ConfigService,
    private balanceService: AccountBalanceService,
    private logoutService: LogoutService,
    private lobbyService: LobbyService,
    private idle: Idle,
  ) { }

  ngOnInit() {
        
    this.eventService.subscribe("event:inactivity:reset", () => {
        this.resetTimeOut();
    });


    this.eventService.subscribe("event:mygames:highlight", () => {
        this.resetTimeOut();
    });
      
    this.userSessionService.getCustomer().subscribe(
      (customer) => {
          this.customer = customer;
          if (customer) {
              let sessionToken = this.userSessionService.getSessionToken();
              this.userSessionService.isAuthenticated().then(isAuthenticated => {
                if (isAuthenticated) {
                  this.timeOutSet();
                  // listen for balance updates when in game to avoid to avoid inacitvity logouts
                  if (!this.balanceSubscription) {
                    this.balanceSubscription = this.balanceService.getBalance().subscribe(
                      (response) => {
                          this.resetTimeOut();
                    });                    
                  }
                }
              });
          } else {
              this.clearIdleObserversArray();
          }
      }
    );    

    this.idleTime =  Number(this.configService.getConfig().INACTIVITY_IDLE_TIME) || 900;
    this.timeOutTime = Number(this.configService.getConfig().INACTIVITY_TIMEOUT) || 15;
    this.idleEventsTriggerList = this.configService.getConfig().INACTIVITY_EVENTS_LIST || 'mousedown touchstart touchmove';
}

  resetTimeOut() {
      this.idle.stop();
      this.idle.watch();
      this.timedOut = false;
  }

  timeOutSet() {
      this.idle.setIdle(this.idleTime); //starts if user is idle for a certain number of seconds
      this.idle.setTimeout(this.timeOutTime); //if user doesn't respond, he/she will be timed out and logged out

      //this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
     
      this.idle.setInterrupts(this.createCustomInterruptSources(null));
    
      this.idle.onTimeout.subscribe(() => {
        if(!this.lobbyService.isAutomationRunning()) {
          this.timedOut = true;
          this.onTimeout();
        }
      });
    

      this.idle.onTimeoutWarning.subscribe((countdown) => {
          console.log('You will time out in ' + countdown + ' seconds!');
      });
  }

  clearIdleObserversArray() {
      this.idle.stop();
      this.idle.onTimeout.observers.length = 0;
      this.idle.onIdleEnd.observers.length = 0;
      this.idle.onIdleStart.observers.length = 0;
      this.idle.onTimeoutWarning.observers.length = 0;
      this.idle.onIdleEnd.observers.length = 0;
  } 

  onTimeout() {
      this.clearIdleObserversArray();
      this.logoutService.callLogout({code: 'INACTIVITY', reason: 'APP_INACTIVITY'})
  }
  
  createCustomInterruptSources(options) {
    return [
        new DocumentInterruptSource(this.idleEventsTriggerList, options),
        new StorageInterruptSource(options)
    ];
  }

  ngOnDestroy() {
    this.balanceSubscription?.unsubscribe();
  }

}
